import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "row row-cols-1 row-cols-sm-2 row-cols-md-2 row-cols-lg-4 row-cols-xl-4" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = { class: "col" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "col" }
const _hoisted_7 = { class: "col" }
const _hoisted_8 = { class: "d-flex flex-row justify-content-end" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_10 = { class: "d-flex flex-column" }
const _hoisted_11 = { class: "align-self-end" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", null, null, -1)
const _hoisted_13 = { class: "demo-pagination-block mt-3 d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Operation = _resolveComponent("Operation")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_form, {
      onSubmit: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["prevent"])),
      class: "mt-2",
      "label-position": 'right',
      "label-width": 'auto'
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_el_form_item, {
              class: "w-100",
              label: _ctx.t('PJCode') + ':'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.searchCriteria.pjCode,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchCriteria.pjCode) = $event)),
                  modelModifiers: { trim: true },
                  onKeyup: _withKeys(_ctx.onInputFieldEnterKeyUp, ["enter"]),
                  clearable: "",
                  placeholder: _ctx.t('placeholder.input')
                }, null, 8, ["modelValue", "onKeyup", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_form_item, {
              class: "w-100",
              label: _ctx.t('creator') + ':'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.searchCriteria.creatorKeyword,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchCriteria.creatorKeyword) = $event)),
                  onKeyup: _withKeys(_ctx.onInputFieldEnterKeyUp, ["enter"]),
                  clearable: "",
                  placeholder: _ctx.t('placeholder.input')
                }, null, 8, ["modelValue", "onKeyup", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_el_form_item, {
              class: "w-100",
              label: _ctx.t('site') + ':'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  placeholder: _ctx.t('placeholder.select'),
                  loading: _ctx.isSiteLoading,
                  "loading-text": _ctx.t('loading'),
                  onVisibleChange: _ctx.onSiteListShown,
                  modelValue: _ctx.searchCriteria.site,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchCriteria.site) = $event)),
                  "value-key": "id",
                  class: "w-100",
                  onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.searchCriteria.factory = undefined)),
                  clearable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sites, (site) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: site.id,
                        label: site.name,
                        value: site
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["placeholder", "loading", "loading-text", "onVisibleChange", "modelValue"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_form_item, {
              class: "w-100",
              label: _ctx.t('factory') + ':'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  placeholder: _ctx.t('placeholder.select'),
                  modelValue: _ctx.searchCriteria.factory,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searchCriteria.factory) = $event)),
                  "value-key": "id",
                  class: "w-100",
                  clearable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchCriteria.site?.factories, (factory) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: factory.id,
                        label: factory.name,
                        value: factory
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["placeholder", "modelValue"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_el_form_item, {
              class: "w-100",
              label: _ctx.t('startDate') + ':'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.searchCriteria.startDate,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.searchCriteria.startDate) = $event)),
                  "value-format": "YYYY-MM-DD",
                  type: "month",
                  placeholder: _ctx.t('placeholder.date'),
                  style: {"width":"100%"},
                  clearable: ""
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_el_form_item, {
              class: "w-100",
              label: _ctx.t('endDate') + ':'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.searchCriteria.endDate,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.searchCriteria.endDate) = $event)),
                  "value-format": "YYYY-MM-DD",
                  type: "month",
                  placeholder: _ctx.t('placeholder.date'),
                  style: {"width":"100%"},
                  clearable: ""
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"])
          ])
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_el_button, {
        type: "",
        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onClearSearchCriteriaClicked()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t("clear")), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onSearchProjectClicked()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t("search")), 1)
        ]),
        _: 1
      })
    ]),
    _hoisted_9,
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_el_popover, {
          placement: "bottom",
          onHide: _ctx.onColDisplayCtrlPanelHidded,
          Title: _ctx.t('column'),
          trigger: "click"
        }, {
          reference: _withCtx(() => [
            _createVNode(_component_el_button, { link: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, { size: 20 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Operation)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.colDisplayCtrl[0],
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.colDisplayCtrl[0]) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("PJCode")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.colDisplayCtrl[1],
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.colDisplayCtrl[1]) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("period")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.colDisplayCtrl[2],
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.colDisplayCtrl[2]) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("startMonth")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.colDisplayCtrl[3],
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.colDisplayCtrl[3]) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("endMonth")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.colDisplayCtrl[4],
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.colDisplayCtrl[4]) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("factories")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.colDisplayCtrl[5],
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.colDisplayCtrl[5]) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("factorys")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.colDisplayCtrl[6],
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.colDisplayCtrl[6]) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("team")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.colDisplayCtrl[7],
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.colDisplayCtrl[7]) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("payRate")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.colDisplayCtrl[8],
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.colDisplayCtrl[8]) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("creator")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.colDisplayCtrl[9],
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.colDisplayCtrl[9]) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("createDate")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _: 1
        }, 8, ["onHide", "Title"])
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        ref: "projectTableRef",
        class: "w-100",
        type: "selection",
        "max-height": 450,
        data: _ctx.displayProjects,
        stripe: true,
        "highlight-current-row": "",
        onCurrentChange: _ctx.onProjectSelectChanged,
        onSortChange: _ctx.onSortChanged
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            width: "70",
            prop: "radio",
            fixed: "left",
            align: "center",
            label: _ctx.t('select')
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_radio, {
                modelValue: _ctx.tableRadio,
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.tableRadio) = $event)),
                label: scope.row.id
              }, {
                default: _withCtx(() => [
                  _hoisted_12
                ]),
                _: 2
              }, 1032, ["modelValue", "label"])
            ]),
            _: 1
          }, 8, ["label"]),
          (_ctx.colDisplayCtrl[0])
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 0,
                "min-width": "140",
                sortable: "custom",
                label: _ctx.t('PJCode'),
                prop: "pjCode"
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.colDisplayCtrl[1])
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 1,
                "min-width": "80",
                sortable: "custom",
                label: _ctx.t('period'),
                prop: "periodNum"
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.colDisplayCtrl[2])
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 2,
                "min-width": "120",
                sortable: "custom",
                label: _ctx.t('startMonth'),
                prop: "startMonth"
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.colDisplayCtrl[3])
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 3,
                "min-width": "120",
                sortable: "custom",
                label: _ctx.t('endMonth'),
                prop: "endMonth"
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.colDisplayCtrl[4])
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 4,
                "min-width": "120",
                sortable: "custom",
                label: _ctx.t('factories'),
                prop: "siteName"
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.colDisplayCtrl[5])
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 5,
                "min-width": "120",
                sortable: "custom",
                label: _ctx.t('factorys'),
                prop: "factoryName"
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.colDisplayCtrl[6])
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 6,
                "min-width": "120",
                sortable: "custom",
                label: _ctx.t('team'),
                prop: "teamNum"
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.colDisplayCtrl[7])
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 7,
                "min-width": "120",
                sortable: "custom",
                label: _ctx.t('payRate'),
                prop: "workRate"
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.colDisplayCtrl[8])
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 8,
                "min-width": "120",
                sortable: "custom",
                label: _ctx.t('creator'),
                prop: "creatorDisplayName"
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.colDisplayCtrl[9])
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 9,
                "min-width": "120",
                sortable: "custom",
                label: _ctx.t('createDate'),
                prop: "createTime"
              }, null, 8, ["label"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["data", "onCurrentChange", "onSortChange"])), [
        [
          _directive_loading,
          _ctx.isTableLoading,
          void 0,
          {
            fullscreen: true,
            lock: true
          }
        ]
      ])
    ]),
    _createVNode(_component_el_row, {
      justify: "end",
      class: "mt-3"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_el_pagination, {
                currentPage: _ctx.currentPage,
                "onUpdate:currentPage": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.currentPage) = $event)),
                "page-size": _ctx.pageSize,
                "onUpdate:page-size": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.pageSize) = $event)),
                "pager-count": _ctx.paginatorSetup.pagerCount,
                layout: _ctx.paginatorSetup.layout,
                small: _ctx.paginatorSetup.small,
                "page-sizes": [20, 50, 100],
                total: _ctx.filteredProjects.length,
                onSizeChange: _ctx.onPagesizeChanged,
                onCurrentChange: _ctx.onCurrentPageChanged,
                justify: "end"
              }, null, 8, ["currentPage", "page-size", "pager-count", "layout", "small", "total", "onSizeChange", "onCurrentChange"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}